// Comercial's small marks: an organization type, a contact label, or a state
// (archived, inactive, inherited from a subordinate). Fixed, quiet colours so
// they read the same in every list and card.
const COLORES = {
  tipo:      'bg-sky-50 text-sky-800 ring-sky-200',
  etiqueta:  'bg-violet-50 text-violet-800 ring-violet-200',
  archivado: 'bg-gray-100 text-gray-600 ring-gray-200',
  inactivo:  'bg-amber-50 text-amber-800 ring-amber-200',
  heredado:  'bg-white text-gray-500 ring-gray-200',
}

export default function ComercialChip({ variante = 'tipo', title, children }) {
  return (
    <span title={title}
      className={`inline-flex items-center max-w-full truncate rounded-full px-2 py-0.5 text-[11px] font-medium ring-1 ring-inset ${COLORES[variante] || COLORES.tipo}`}>
      {children}
    </span>
  )
}
